import { atom } from '@exodus/headless-ui';
const isExchangingAtom = atom((get, { selectors }) => {
    const exchangeStatus = get(selectors.exchange.status);
    return Boolean(exchangeStatus?.status);
});
export default isExchangingAtom;
